import { render, staticRenderFns } from "./AscRoleGrid.vue?vue&type=template&id=267a4521&"
import script from "./AscRoleGrid.vue?vue&type=script&lang=js&"
export * from "./AscRoleGrid.vue?vue&type=script&lang=js&"
import style0 from "./AscRoleGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports